const ROOT_FONT_SIZE = 16;
const BUTTON_BORDER_RADIUS = 1000;

export { BUTTON_BORDER_RADIUS, ROOT_FONT_SIZE };
export default { BUTTON_BORDER_RADIUS, ROOT_FONT_SIZE };
